<template>
  <div class="font-12 d-flex">
    <div class="position-absolute" :class="{'mt-n13px font-11': input_esta_em_focu || TEXTO_PESQUISA.length > 0}">
      <label for="input-pesquisa">Pesquisa</label>
    </div>

    <input
      id="input-pesquisa"
      v-model="TEXTO_PESQUISA"
      class="w-full input-pesquisa"
      @focus="ev => {ev.target.select();input_esta_em_focu = true;}"
      @blur="input_esta_em_focu = false"
    />

    <v-icon :size="17" class="ml-n4">mdi-magnify</v-icon>
  </div>
</template>

<script>
export default {
  name: "InputPesquisa",
  model: {
    prop: 'modelValue',
    event: "update:modelValue"
  },
  props: {
    modelValue: String,
  },
  data: () => ({
    input_esta_em_focu: false
  }),
  computed: {
    TEXTO_PESQUISA: {
      get() {
        return this.modelValue;
      },
      set(valor) {
        this.$emit("update:modelValue", valor);
      }
    }
  }
}
</script>

<style scoped>
.input-pesquisa {
  border-bottom: 1px solid #b0b0b0;
  outline: none;
}
.input-pesquisa:focus {
  border-bottom: 1px solid #0000bd;
}
</style>
